import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { translate } from 'react-i18next'

import _ from 'lodash'

import { Loader } from 'semantic-ui-react'

import { AuthorizationError, EventEmitter } from './error_handling'
import Home from './Home'
import PublicHome from './PublicHome'

class Main extends Component {
  constructor (props) {
    super(props)

    const { aufschaltungen } = props
    this.state = {
      aufschaltung: (aufschaltungen && aufschaltungen.length > 0 && aufschaltungen[0]) || null,
      atoken: null,
      lang: 'de'
    }
  }

  componentDidMount () {
    const { preferences } = this.props
    if (preferences) this.changeLanguage(preferences.lang)
    EventEmitter.on('signalError', this.onErrorAppeared)
  }

  componentWillUnmount () {
    // TODO: sync to server
    clearInterval(this.interval)
    EventEmitter.off('signalError', this.onErrorAppeared)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.aufschaltungen !== nextProps.aufschaltungen) {
      const { aufschaltung } = this.state
      const au = nextProps.aufschaltungen.find(au => au.id === aufschaltung.id)
      this.setState({ aufschaltung: au })
    }
    const { preferences } = this.props
    if (preferences && preferences.lang !== nextProps.preferences.lang) {
      this.changeLanguage(nextProps.preferences.lang)
    }
  }

  changeLanguage = (lang) => {
    const { i18n } = this.props
    i18n.changeLanguage(lang)
    this.setState({ lang: lang })
  }

  onErrorAppeared = ({ error }) => {
    if (error.errorName === AuthorizationError.errorName) {
      this.props.history.push('/home')
    } // there might be some more to come...
  }

  handleChangeAufschaltung ({ match, history }) {
    const { aufschaltungen } = this.props
    const au = aufschaltungen.find(au => au.id === match.params.au_id)
    this.setState({ aufschaltung: au })
    history.replace('/home')
  }

  startPath({userInfo, aufschaltung}) {
    // compute sensible start path from scopes  -- must match LeftMenu...

    if (!userInfo || !userInfo.scopes || !aufschaltung) {
      return '/home'
    }
    if (_.includes(userInfo.scopes, 'view:dashboard')) {
      return '/home'
    }
    if (_.includes(userInfo.scopes, 'view:aufschaltung-profiles')) {
      if (aufschaltung.profiles && aufschaltung.profiles.length >= 1 && aufschaltung.profiles[0].nickname) {
        return `/profile/${aufschaltung.profiles[0].nickname}`
      }
    }
    if (_.includes(userInfo.scopes, 'view:aufschaltung-apis')) {
      if (aufschaltung.apis && aufschaltung.apis.length >= 1 && aufschaltung.apis[0].nickname) {
        return `/api/${aufschaltung.apis[0].nickname}`
      }
    }
    if (_.includes(userInfo.scopes, 'view:aufschaltung-apps')) {
      if (aufschaltung.apps && aufschaltung.apps.length >= 1 && aufschaltung.apps[0].nickname) {
        return `/app/${aufschaltung.apps[0].nickname}`
      }
    }
    if (_.includes(userInfo.scopes, 'view:documentation')) {
      return '/doc'
    }
    return '/home'
  }

  render () {
    const {
      aufschaltungen,
      preferences,
      userInfo,
      redirectToLoginAfterLogout } = this.props
    const { aufschaltung, lang } = this.state

    return (
      <div>
        
        { userInfo ? (
          <Home userInfo={userInfo}
            lang={lang}
            preferences={preferences}
            onChangeLanguage={this.changeLanguage}
            aufschaltung={aufschaltung}
            aufschaltungen={aufschaltungen} />
          ) : (<PublicHome lang={lang} onChangeLanguage={this.changeLanguage} />)
        }

        <Switch>
          <Route exact path='/' render={({location, history}) => {
            // do not show public root -- go either to home or login screen
            if (userInfo) {
              history.replace(this.startPath({userInfo, aufschaltung}))
              return <Loader active inline='centered' size='big' />
            } else {
              if (redirectToLoginAfterLogout) {
                setTimeout(() => { history.replace('/login') }, 1500)
              }
              return ''
            }
          }} />

          <Route exact path='/home' render={({location, history}) => {
            // redirect to alternate start page if dashboard view is not allowed by userInfo.scopes
            if (userInfo) {
              const effectiveStartPath = this.startPath({userInfo, aufschaltung})
              if (effectiveStartPath !== '/home') {
                history.replace(effectiveStartPath)
                return <Loader active inline='centered' size='big' />
              }
            }
            return null
          }} />

          <Route path='/aufschaltung/:au_id' render={
            ({ match, history }) => {
              this.handleChangeAufschaltung({ match, history })
              return <Loader active inline='centered' size='big' />
            }} />
        </Switch>
      </div>
    )
  }
}

export default withRouter(translate('translations')(Main))



// WEBPACK FOOTER //
// ./src/components/Main.js